import { LegislationEmployeeCostSectionDTO } from "../../models/legislation-employee-cost-section/legislation-employee-cost-section-dto";
import { LegislationEmployeeCostSectionSTO } from "../../models/legislation-employee-cost-section/legislation-employee-cost-section-sto";
import { BaseApiService } from "../base";

export class LegislationEmployeeCostSectionApiService extends BaseApiService<
  LegislationEmployeeCostSectionDTO,
  LegislationEmployeeCostSectionSTO
> {
  constructor() {
    super({
      servicePath: "/LegislationEmployeeCostSection",
      loadItemsPath: "/GetLegislationEmployeeCostSection",
      saveItemsPath: "/SaveLegislationEmployeeCostSection",
    });
  }
}
